import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box, useMediaQuery, useTheme } from '@mui/material';

import MultiColorPicker from '~/components/atoms/color-picker/MultiColorPicker';
import Accordion from '~/components/ui/Accordion/Accordion';
import Select from '~/components/ui/Select';
import { DESKTOP_MIN_WIDTH, FONTS } from '~/constants/common';
import { useAppDispatch } from '~/hooks/useRedux';
import CreateQRContentBlockLayout from '~/pages/CreateQR/components/CreateQRContentBlockLayout/CreateQRContentBlockLayout';
import { socialMediaSlice, updateSocialSiteThunk } from '~/store/reducers/previewScreens/social-media';
import { getSocialMediaReducer } from '~/store/reducers/previewScreens/social-media/selectors';

const { actions } = socialMediaSlice;

export default function Appearance() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const isDesktop = useMediaQuery(theme.breakpoints.up(DESKTOP_MIN_WIDTH));
  const { micrositeData, fonts, bacgkroundColor } = useSelector(getSocialMediaReducer);

  const getReplacedInitialColor = () => {
    if (bacgkroundColor) return bacgkroundColor;
  };

  const handleChangeFont = (field, e) => {
    const value = e.target.value;

    dispatch(actions.setFonts({ field, value }));
    dispatch(
      updateSocialSiteThunk({
        fonts: {
          ...fonts,
          [field]: value,
        },
      }),
    );
  };

  return (
    <CreateQRContentBlockLayout type="appearance">
      <Accordion
        defaultExpanded
        variant="child"
        summary={t('basicTemplateLabels:tmplDesign')}
        details={
          <MultiColorPicker
            setColorValues={(val) => dispatch(actions.setBackgroundColor(val))}
            initialColors={[['#1E88E5'], ['#7B1FA2'], ['#C62828'], ['#EF6C00'], ['#2E7D32']]}
            selectedColors={[micrositeData?.design?.primary]}
            getReplacedInitialColor={getReplacedInitialColor}
            onSketchPickerChange={(val) => dispatch(actions.setBackgroundColor(val))}
            blurFunction={(arr) => {
              if (micrositeData?.id) {
                dispatch(
                  updateSocialSiteThunk({
                    design: {
                      primary: arr[0],
                    },
                  }),
                );
              }
            }}
          />
        }
      />
      <Accordion
        defaultExpanded
        variant="child"
        hideBottomBorder
        summary={t('basicTemplateLabels:tmplFonts')}
        details={
          <Box display="flex" flexDirection={isDesktop ? 'row' : 'column'} sx={{ gap: '16px' }}>
            <Select
              items={FONTS}
              onChange={(e) => handleChangeFont('title', e)}
              fullWidth
              label={t('other:title')}
              defaultValue={fonts?.title || FONTS[3].value}
            />
            <Select
              items={FONTS}
              onChange={(e) => handleChangeFont('text', e)}
              fullWidth
              label={t('other:text')}
              defaultValue={fonts?.text || FONTS[3].value}
            />
          </Box>
        }
      />
    </CreateQRContentBlockLayout>
  );
}
